/* eslint-disable linebreak-style */
import { Button } from '@mui/material';
import i18n from '../common/i18n';
import '../../assests/css/headerStyle.css';
import MenuItems from './MenuItems';

import { AUTOGESTION, COMMERCE } from '../../api/env';
import safeGetEnv from '../../prerender';

const NavBar = () => {
  // Links derived from env vars
  const COMMERCE_LINK = safeGetEnv(COMMERCE);
  const CLIENT_LINK = safeGetEnv(AUTOGESTION);

  // Menu configuration for "Dónde comprar"
  // i18n.headerMenuPhysicalCommerce is already {title, route} — extract only .title for the subMenu label
  const headerMenuWhereToBuy = {
    title: i18n.headerWhereToBuyTitle,
    subMenu: [
      {
        title: i18n.headerMenuPhysicalCommerce.title,
        route: i18n.headerMenuPhysicalCommerce.route,
      },
    ],
  };

  // i18n menu values are already objects {title, route} — use them directly
  const menuItems = [
    i18n.headerMenuHome,
    headerMenuWhereToBuy,
    i18n.headerMenuBlog,
    i18n.headerMenuHelp,
  ];

  return (
    <nav>
      <ul className="menus">
        {menuItems.map((item) => (
          <MenuItems items={item} key={item.title} />
        ))}
        <li>
          <a href={COMMERCE_LINK} target="_blank" rel="noopener noreferrer nofollow" style={{ textDecoration: 'none' }}>
            <Button sx={{ marginLeft: '10px' }} variant="contained" className="ButtonMagenta ButtonYellow">
              {i18n.headerCommerce}
            </Button>
          </a>
          <a href={CLIENT_LINK} target="_blank" rel="noopener noreferrer nofollow" style={{ textDecoration: 'none' }}>
            <Button sx={{ marginLeft: '10px' }} variant="contained" className="ButtonMagenta">
              {i18n.headerClient}
            </Button>
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default NavBar;
